import { asyncApi } from '@/services/apiService'

const _baseEndpoint = `${process.env.VUE_APP_BASE_API}/api/master/tariff/subscribe`;

const tariffSubscribeService = {
  toggleSubscribe: async (payload, onBeginCallback, onFinallyCallback) => {
    return asyncApi.post(_baseEndpoint, payload, onBeginCallback, onFinallyCallback);
  }
}

export {
  tariffSubscribeService
}



// WEBPACK FOOTER //
// ./src/services/master/tariffSubscribeService.js